import type { FC } from 'react';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import { isEmpty } from '@/utils/objects.utils';

interface AsideTopEntitiesListProps {
  className?: string;
  title: string;
  list: { name: string; href: string }[];
}
export const AsideTopEntitiesList: FC<AsideTopEntitiesListProps> = ({ className, title, list }) => {
  return (
    <aside className={cn('w-full', className)}>
      <p className="text-light text-lg font-medium tracking-normal leading-5.5">{title}</p>
      {
        !isEmpty(list) && (
          <ul className="flex flex-col gap-2 mt-3">
            {
              list.map(item => (
                <li key={item.href} className="text-sm leading-5 md:text-base md:leading-6">
                  <Link href={item.href} className="text-c300 cursor-pointer hover:text-c400 transition-colors">{item.name}</Link>
                </li>
              ))
            }
          </ul>
        )
      }

    </aside>
  );
};
